import React, {useRef, useState} from "react";
import {GatsbyImage} from "gatsby-plugin-image";
import {useScrollMonitor} from 'scrollmonitor-hooks';
import {Link} from "gatsby";
import ArrowLink from "../global/arrow-link";

const ProjectCard = (
  {
    theme = "default",
    contentPosition = "default",
    projectData = null,
    imageData = null,
    imagePosition = 'center',
  }
  ) => {
  const parentRef = useRef(null);
  const [cardViewClass, setCardViewClass] = useState('');

  const [isHover, setHover] = useState(false);
  const [linkTheme, setLinkTheme] = useState(theme === 'white' ? 'dark' : 'white');

  const cardMouseEnterHandle = () => {
    setLinkTheme('white');
    setHover(true);
  }

  const cardMouseLeaveHandle = () => {
    setLinkTheme(theme === 'white' ? 'dark' : 'white');
    setHover(false);
  }

  const cardViewCallbacks = {
    enterViewport: () => {
      setCardViewClass('project-card--in-view');
    }
  }

  useScrollMonitor(parentRef, cardViewCallbacks);

  return (
    <div
      className={`project-card project-card--${theme ? theme : "default"} ${cardViewClass}`}
      ref={parentRef}
    >
      {projectData && (
        <Link
          className="project-card__link-wrapper"
          to={projectData.link.url}
          onMouseEnter={cardMouseEnterHandle}
          onMouseLeave={cardMouseLeaveHandle}
        >
          <div className={`project-card__content-wrapper project-card__content-wrapper--${contentPosition ? contentPosition : "default"}`}>
            <div className="project-card__title-wrapper">
              <h4 className="project-card__title">{projectData.title}</h4>
            </div>
            <ArrowLink
              text={projectData.link.title}
              theme={linkTheme}
              isLink={false}
              isAnimation={isHover}
            />
          </div>
        </Link>
      )}
      {imageData && (
        <div className="project-card__media-wrapper">
          <GatsbyImage
            className={`project-card__image project-card__image--${imagePosition}`}
            image={imageData}
            alt="Evo"
          />
        </div>
      )}
    </div>
  )
}

export default ProjectCard
